var map = {
	"./2000-12.jpg": 788,
	"./2001-12.jpg": 339,
	"./2002-12.jpg": 994,
	"./2003-12.jpg": 681,
	"./2004-12.jpg": 600,
	"./2005-12.jpg": 575,
	"./2006-12.jpg": 606,
	"./2007-12.jpg": 877,
	"./2008-12.jpg": 228,
	"./2009-12.jpg": 555,
	"./2010-12.jpg": 349,
	"./2011-12.jpg": 838,
	"./2012-12.jpg": 175,
	"./2013-12.jpg": 120,
	"./2014-12.jpg": 905,
	"./2015-12.jpg": 826,
	"./2016-12.jpg": 771,
	"./2017-12.jpg": 596,
	"./2018-12.jpg": 461,
	"./2019-12.jpg": 457,
	"./2020-12.jpg": 874,
	"./2021-12.jpg": 769,
	"./2022-12.jpg": 316,
	"./2023-12.jpg": 955,
	"./2024-12.jpg": 750,
	"./2025-12.jpg": 725,
	"./Capa.jpg": 453,
	"./Contracapa.jpg": 219,
	"./Covid.jpg": 469,
	"./Credits.jpg": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;